<template>
<div class="chapter">
<div class="inner_page">
<p class="sp-brk"> </p>
<p class="fmh"><span class="epub-b">CONTENTS</span></p>
<p class="cfmh"><span href="#/xhtml/title#tit" title="Link target outside of Sample"><span class="epub-i">Title Page</span></span></p>
<p class="cfmh"><span href="#/xhtml/copyn#copyn" title="Link target outside of Sample"><span class="epub-i">Copyright Notice</span></span></p>
<p class="cfmh"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample"><span class="epub-i">Dedication</span></span></p>
<p class="cfmh"><a href="#/xhtml/epigraph#epi"><span class="epub-i">Epigraph</span></a></p>
<p class="cfmh-bot"><a href="#/xhtml/intro#intro"><span class="epub-i">Introduction</span></a></p>
<p class="cct">1:   <a href="#/xhtml/chapter1#ch1">Setting the Scene: The Romanov Tercentenary</a></p>
<p class="cct">2:   <a href="#/xhtml/chapter2#ch2">The Empress’s Illness, and Her Friend Ania</a></p>
<p class="cct">3:   <a href="#/xhtml/chapter3#ch3">Mystical Circles, and the Struggle to Produce an Heir</a></p>
<p class="cct">4:   <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Autocracy in Crisis</span></p>
<p class="cct">5:   <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">Beginnings</span></p>
<p class="cct">6:   <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">After the Coronation</span></p>
<p class="cct">7:   <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">Family Matters</span></p>
<p class="cct">8:   <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Grigory the Wonder-Worker</span></p>
<p class="cct">9:   <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Upsets at Home, and the Beginning of War</span></p>
<p class="cct">10: <span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">The Great Fight</span></p>
<p class="cct">11: <span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">From Command to Abdication</span></p>
<p class="cct-bot">12: <span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">From Ex’s to Icons</span></p>
<p class="cfmh"><span href="#/xhtml/notes#notes" title="Link target outside of Sample"><span class="epub-i">Notes</span></span></p>
<p class="cfmh"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample"><span class="epub-i">Select Bibliography</span></span></p>
<p class="cfmh"><span href="#/xhtml/index#indx" title="Link target outside of Sample"><span class="epub-i">Index</span></span></p>
<p class="cfmh"><span href="#/xhtml/illustrations#illu" title="Link target outside of Sample"><span class="epub-i">List of Illustrations</span></span></p>
<p class="cfmh"><span href="#/xhtml/photographs#photo" title="Link target outside of Sample"><span class="epub-i">Photographs</span></span></p>
<p class="cfmh"><span href="#/xhtml/dramatis#drama" title="Link target outside of Sample"><span class="epub-i">Dramatis Personae</span></span></p>
<p class="cfmh"><span href="#/xhtml/tree#tree" title="Link target outside of Sample"><span class="epub-i">Family Tree</span></span></p>
<p class="cfmh"><span href="#/xhtml/backrgg#rgg" title="Link target outside of Sample"><span class="epub-i">Discussion Questions</span></span></p>
<p class="cfmh"><span href="#/xhtml/ack#ack" title="Link target outside of Sample"><span class="epub-i">Acknowledgments</span></span></p>
<p class="cfmh"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample"><span class="epub-i">Also by Virginia Rounding</span></span></p>
<p class="cfmh"><span href="#/xhtml/abouttheauthor#ata" title="Link target outside of Sample"><span class="epub-i">About the Author</span></span></p>
<p class="cfmh"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample"><span class="epub-i">Copyright</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6dbd8502